<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Hospital } from '../../../lib/api';
  import { session } from '../../../lib/auth.svelte';

  let { limit = 8, interactive = true }: { limit?: number; interactive?: boolean } = $props();

  type KardexRow = {
    id?: string;
    medicamentoId?: string;
    dosis?: string;
    via?: string;
    horaProgramada?: string;
    pacienteId?: string;
    estado?: string;
  };

  let rows = $state<KardexRow[]>([]);
  let error = $state<string | null>(null);
  let busy = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const all = await Hospital.kardexPendientes();
      rows = all.slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  async function administrar(id: string) {
    if (!id) return;
    busy = id;
    try {
      await Hospital.administrar(id, session.value?.usuario ?? 'enfermeria');
      await cargar();
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      busy = null;
    }
  }

  function hora(iso?: string) {
    if (!iso) return '—';
    try { return new Date(iso).toLocaleTimeString('es-GT', { hour: '2-digit', minute: '2-digit' }); }
    catch { return iso; }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashCard title="Kárdex pendientes" hint="{rows.length} dosis">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if rows.length === 0 && !error}
    <p class="empty">Sin administraciones pendientes.</p>
  {:else}
    <table class="dash-table">
      <thead><tr><th>Hora</th><th>Dosis</th><th>Vía</th>{#if interactive}<th></th>{/if}</tr></thead>
      <tbody>
        {#each rows as r (r.id)}
          <tr>
            <td class="dash-mono">{hora(r.horaProgramada)}</td>
            <td>{r.dosis ?? r.medicamentoId?.slice(0, 8) ?? '—'}</td>
            <td>{r.via ?? '—'}</td>
            {#if interactive}
              <td>
                <button type="button" class="btn-ok" disabled={busy === r.id} onclick={() => r.id && administrar(r.id)}>
                  {busy === r.id ? '…' : 'Administrar'}
                </button>
              </td>
            {/if}
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</DashCard>

<style>
  .btn-sm { border: 1px solid var(--glass-border); background: var(--glass-bg-card); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-size: 0.78rem; color: var(--text-secondary); font-weight: 600; transition: all 0.2s; }
  .btn-sm:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  .btn-ok { border: 0; background: linear-gradient(135deg, #10b981, #059669); color: #fff; border-radius: 999px; padding: 0.25rem 0.6rem; font-size: 0.72rem; cursor: pointer; font-weight: 600; transition: all 0.2s; }
  .btn-ok:hover { box-shadow: 0 4px 12px rgba(16,185,129,0.35); transform: translateY(-1px); }
  .btn-ok:disabled { opacity: 0.6; cursor: wait; }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
</style>
